<div
  class="alert alert-custom fade show py-2 alert-{{ alertType }}"
  role="alert"
>
  <div class="alert-text">
    {{ message }}
  </div>
</div>
